<div class="center-small-container">
  <h1 class="page-title-center">Cell Phone Change</h1>

  <mat-stepper
    linear
    [selectedIndex]="step()"
    (selectedIndexChange)="step.set($event)"
  >
    <mat-step [stepControl]="cellPhoneForm">
      <form
        class="account-update-form gap-15"
        [formGroup]="cellPhoneForm"
        (ngSubmit)="createToken()"
      >
        <mat-form-field appearance="outline" class="mt-10">
          <mat-label>New cell phone</mat-label>
          <input matInput formControlName="cell_phone" />
        </mat-form-field>

        <button
          mat-flat-button
          class="mat-button-squared-full-width"
          type="submit"
          matTooltip="Continue"
          [disabled]="cellPhoneForm.invalid"
        >
          Continue
        </button>
      </form>
    </mat-step>

    <mat-step [stepControl]="userForm">
      <form
        class="account-update-form gap-15"
        [formGroup]="userForm"
        (ngSubmit)="updateCellPhone()"
      >
        <mat-form-field appearance="outline" class="mt-10">
          <mat-label>New cell phone</mat-label>
          <input matInput formControlName="cell_phone" readonly />

          <button
            class="mr-7"
            mat-button
            matSuffix
            type="button"
            matTooltip="Edit cell phone"
            (click)="changeCellPhone()"
          >
            Edit
          </button>
        </mat-form-field>

        <mat-form-field appearance="outline">
          <mat-label>Code</mat-label>
          <input matInput formControlName="token_code" />
        </mat-form-field>

        @if (resendCellPhoneCodeTimer() > 0) {
          <div class="yellow-container">
            Didn't get a code? Resend it in {{ resendCellPhoneCodeTimer() }}
          </div>
        }

        @if (resendCellPhoneCodeTimer() === 0) {
          <div class="yellow-container">
            Didn't get a code?
            <a matTooltip="Resend Verification Code" (click)="createToken()">
              Resend it
            </a>
          </div>
        }

        <button
          mat-stroked-button
          class="mat-button-squared-full-width"
          type="submit"
          matTooltip="Update"
          [disabled]="userForm.invalid"
        >
          Update
        </button>
      </form>
    </mat-step>
  </mat-stepper>

  <div class="bottom-actions">
    <button mat-button (click)="goBack()" matTooltip="Go back">
      Go back
    </button>
  </div>
</div>